module.exports = __webpack_public_path__ + "static/img/weather02.1728a67c.png";